import { render, staticRenderFns } from "./WarningText.vue?vue&type=template&id=ae3a9cbe&scoped=true"
import script from "./WarningText.vue?vue&type=script&lang=js"
export * from "./WarningText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3a9cbe",
  null
  
)

export default component.exports